import { FilterType } from '@core/enums/filter-type.enum';
import { OperatoriFaqja } from '@core/interfaces/models/operatori-faqja.interface';
import { SplitConfig } from '@core/interfaces/split-config.interface';

export class Defaults {

  public static SplitConfig: SplitConfig = {
    columns: [
      {
        size: 20,
        rows: [
          {
            size: 100,
            order: 1,
            visible: true,
          },
          // {
          //   size: 50,
          //   order: 2,
          //   visible: true,
          // },
        ],
      },
      {
        size: 60,
        rows: [
          {
            size: 100,
            order: 1,
            visible: true,
          },
          // {
          //   size: 50,
          //   order: 2,
          //   visible: true,
          // },
        ],
      },
      {
        size: 20,
        rows: [
          {
            size: 30,
            order: 1,
            visible: true,
          },
          {
            size: 20,
            order: 2,
            visible: true,
          },
          {
            size: 30,
            order: 3,
            visible: true,
          }
        ],
      }
    ],
  };
  
  public static OperatoriFaqja: OperatoriFaqja = {
    id: -1,
    termiKerkimit: '',
    termiFilterit: FilterType.AllWords,
    // renditjaSipas: OrderBy.Headword,
    // tipiRenditjes: OrderType.Ascending,
    splitConfig: JSON.stringify(Defaults.SplitConfig),
    shenimet: '',
    // darkMode: false,
  };
}